<template>
  <transition-group name="fade" mode="out-in">
    <div v-if="note.id" class="note mb-5" :key="note.id">
      <div
        class="note-menu d-flex align-content-center"
        :class="{ visible: showMenu }"
      >
        <ul class="text-left flex-fill">
          <li @click="$router.push('/dashboard')">
            <i class="fa fa-chevron-left"></i>
          </li>
        </ul>
        <ul class="flex-fill d-flex justify-content-end">
          <li>
            <a href="#" @click="setEditor(!editor)"
              ><i class="fa fa-wrench"></i
            ></a>
          </li>
          <li>
            <a href="#" @click="toggleFullScreen"
              ><i class="fa fa-expand"></i
            ></a>
          </li>
        </ul>
        <div
          class="dropdown"
          @mouseover="menuOpen = true"
          @mouseleave="menuOpen = false"
        >
          <a @click.prevent="menuOpen = !menuOpen" class="mx-2">
            <i class="fa fa-ellipsis-h"></i>
          </a>
          <div v-if="menuOpen" class="dropdown-menu show position-absolute">
            <delete-button
              class="dropdown-item"
              :id="$route.params.id"
              @delete="deleted = true"
            ></delete-button>
            <a class="dropdown-item" href="#" @click="exportText('text')"
              >Export as text</a
            >
            <a class="dropdown-item" href="#" @click="exportText('html')"
              >Export as html</a
            >
          </div>
        </div>
      </div>
      <div
        v-show="ready && note"
        class="paper container py-5 px-3 px-md-5"
        :class="{ 'show-editor': editor }"
        sticky-container
      >
        <input
          class="input-title"
          type="text"
          v-model="note.title"
          placeholder="Title"
          @keyup="tryUpdate"
        />
        <div class="category text-left">
          <input
            class="mb-4"
            type="text"
            v-model="note.category"
            placeholder="Category"
            @keyup="tryUpdate"
          />
        </div>
        <quill-editor v-model="note.body" @change="tryUpdate" />
        <div v-if="saved" class="note-footer position-absolute p-3 p-md-2rem">
          <div>saved</div>
        </div>
      </div>
    </div>
    <div
      v-else
      :key="'bookloader'"
      class="bookloader-contaier w-100 d-flex justify-content-center align-content-center"
    >
      <book-loader class="align-self-center" />
    </div>
  </transition-group>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { quillEditor } from "vue-quill-editor";

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import debounce from "lodash.debounce";
import DeleteButton from "@/components/buttons/DeleteButton.vue";
import BookLoader from "../components/loader/BookLoader.vue";

export default {
  name: "Note",
  components: { quillEditor, DeleteButton, BookLoader },
  data() {
    return {
      ready: false,
      menuOpen: false,
      note: {},
      lastBodyHeight: null,
      saved: false,
      deleted: false,
      hasChange: false,
      showMenu: true
    };
  },
  computed: {
    ...mapGetters({
      editor: "getEditor",
      getNote: "getNote"
    })
  },
  watch: {
    "$route.params.id": async function(id) {
      console.log("id changed" + id);
      this.note = await this.fetchNote(id);
      console.log(this.note);
    }
  },
  methods: {
    ...mapActions({
      fetchNote: "fetchNote",
      updateNote: "updateNote",
      setEditor: "setEditor"
    }),
    toggleFullScreen() {
      const doc = window.document;
      const docEl = doc.documentElement;

      const requestFullScreen =
        docEl.requestFullscreen ||
        docEl.mozRequestFullScreen ||
        docEl.webkitRequestFullScreen ||
        docEl.msRequestFullscreen;
      const cancelFullScreen =
        doc.exitFullscreen ||
        doc.mozCancelFullScreen ||
        doc.webkitExitFullscreen ||
        doc.msExitFullscreen;

      const condition =
        !doc.fullscreenElement &&
        !doc.mozFullScreenElement &&
        !doc.webkitFullscreenElement &&
        !doc.msFullscreenElement;

      condition ? requestFullScreen.call(docEl) : cancelFullScreen.call(doc);
    },
    update: debounce(async function() {
      await this.updateNote(this.note);
      this.hasChange = false;
      this.saved = true;
      setTimeout(() => {
        this.saved = false;
      }, 2000);
    }, 800),
    tryUpdate() {
      if (!this.hasChange) this.hasChange = true;
      this.update();
    },
    strip(text) {
      return text.replace(/<[^>]*>?/gm, "");
    },
    htmltoText(html) {
      let text = html;
      text = text.replace(/\n/gi, "");
      text = text.replace(/<style([\s\S]*?)<\/style>/gi, "");
      text = text.replace(/<script([\s\S]*?)<\/script>/gi, "");
      text = text.replace(/<a.*?href="(.*?)[?"].*?>(.*?)<\/a.*?>/gi, " $2 $1 ");
      text = text.replace(/<\/div>/gi, "\n\n");
      text = text.replace(/<\/li>/gi, "\n");
      text = text.replace(/<li.*?>/gi, "  *  ");
      text = text.replace(/<\/ul>/gi, "\n\n");
      text = text.replace(/<\/p>/gi, "\n\n");
      text = text.replace(/<br\s*[/]?>/gi, "\n");
      text = text.replace(/<[^>]+>/gi, "");
      text = text.replace(/^\s*/gim, "");
      text = text.replace(/ ,/gi, ",");
      text = text.replace(/ +/gi, " ");
      text = text.replace(/\n+/gi, "\n\n");
      return text;
    },
    exportText(type) {
      let note = "<h1>this.note.title</h1><br><br>" + this.note.body;
      if (type === "text") {
        note = this.htmltoText(note);
      }
      var blob = new Blob([note], { type: "text/plain" });
      var url = window.URL.createObjectURL(blob);
      var a = document.createElement("a");
      a.href = url;
      a.download = this.note.title;
      a.click();
      window.URL.revokeObjectURL(url);
    },
    autoScroll() {
      console.log("autoscrolled");
      let newBodyHeight = document.body.scrollHeight;
      const currentDocumentHeight =
        document.documentElement.scrollTop +
        document.documentElement.clientHeight;
      if (
        newBodyHeight > this.lastBodyHeight &&
        currentDocumentHeight === this.lastBodyHeight
      ) {
        window.scrollBy(0, 50);
      }
      this.lastBodyHeight = newBodyHeight;
    }
  },
  async mounted() {
    try {
      this.note = await this.fetchNote(this.$route.params.id);
      setTimeout(() => {
        this.showMenu = false;
      }, 1500);
    } catch (e) {
      this.$router.push({ name: "dashboard" });
    }

    this.lastBodyHeight = document.body.scrollHeight;

    setTimeout(() => {
      this.ready = true;
      const eventTarget = document.getElementsByClassName("ql-editor")[0];
      eventTarget.addEventListener("keyup", () => {
        this.autoScroll();
      });
    }, 1000);

    document.addEventListener("scroll", function() {
      const scrollTop =
        window.pageYOffset !== undefined
          ? window.pageYOffset
          : (
              document.documentElement ||
              document.body.parentNode ||
              document.body
            ).scrollTop;
      if (scrollTop > 70) {
        document.body.classList.add("scrolled");
      } else {
        document.body.classList.remove("scrolled");
      }
    });
  },
  async deactivated() {
    const eventTarget = document.getElementsByClassName("ql-editor")[0];
    eventTarget.removeEventListener("keyup", () => {
      this.autoScroll();
    });
    if (!this.deleted && this.hasChange) {
      await this.updateNote(this.note);
    }
  }
};
</script>

<style lang="scss">
.bookloader-contaier {
  min-height: 70vh;
}
/* Reset for quill editor */

.ql-toolbar {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  background: #fff;
}

.scrolled .ql-toolbar {
  position: fixed;
  top: 0;
  width: 100%;
}
.ql-toolbar.ql-snow {
  border: 0;
  opacity: 0;
  max-height: 0;
  transition: opacity 0.3s, max-height 0.5s ease-in-out;
  /* remove unneeded items from editor */
  .ql-script,
  .ql-image,
  .ql-clean {
    display: none;
  }
}

.show-editor {
  .ql-toolbar.ql-snow {
    opacity: 1;
    height: auto;
    max-height: 150px;
  }
}

.ql-container {
  font-size: 16px;
  &.ql-snow {
    border: 0;
  }
}
.note-menu {
  width: 100%;
  color: white;
  opacity: 0;
  padding: 4px 0;
  transition: opacity 0.5s;
  background-color: rgba(255, 255, 255, 0.2);
  &:hover,
  &.visible {
    opacity: 1;
  }
  &.top-sticky {
    background: white;
    box-shadow: 2px 0 4px rgba(0, 0, 0, 0.1);
    li,
    a {
      color: black;
    }
  }
  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    align-content: center;
    display: flex;
    li {
      cursor: pointer;
      margin: 0 0.5rem;
      align-self: center;
    }
  }
  a {
    color: white;
  }
  .dropdown-menu {
    right: 0;
    left: auto;
    margin-top: -3px;
    a {
      color: black;
    }
  }
}
.paper {
  position: relative;
  min-height: 80vh;
  background: #fff;
  margin: 0 auto;
  transition: 0.5s ease-in-out;
  padding-bottom: 3rem;
  .note-footer {
    bottom: 0;
    left: 0;
    width: 100%;
  }
  .input-title {
    border: 0;
    width: 100%;
    outline: 0;
    font-size: 1.5rem;
    padding: 0.5rem 15px 0;
    color: #444;
  }
}
</style>
